/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: ''
  }
})
